import React from 'react';
import { useHistory } from 'react-router-dom';
import { Type, Hash, Palette, MessageSquare, Music, Moon } from 'lucide-react';
import BigButton from '../components/BigButton';
import Layout from '../components/Layout';
import './Home.css';
import { useSpeech } from '../hooks/useSpeech';

const Home = () => {
    const history = useHistory();
    const { speak } = useSpeech();

    const modules = [
        { id: 'alphabets', label: 'Alphabets', path: '/alphabets', color: '#FF6B6B', icon: <Type size={48} /> }, // Primary red
        { id: 'numbers', label: 'Numbers', path: '/numbers', color: '#4ECDC4', icon: <Hash size={48} /> }, // Teal
        { id: 'colors', label: 'Colors', path: '/colors', color: '#FFE66D', icon: <Palette size={48} /> }, // Yellow
        { id: 'words', label: 'Words', path: '/words', color: '#1A535C', icon: <MessageSquare size={48} /> }, // Dark Tech
        { id: 'rhymes', label: 'Rhymes', path: '/rhymes', color: '#9B5DE5', icon: <Music size={48} /> }, // Purple
        { id: 'stories', label: 'Stories', path: '/stories', color: '#F15BB5', icon: <Moon size={48} /> }, // Pink
    ];

    const handleNavigate = (module) => {
        speak(module.label);
        setTimeout(() => {
            history.push(module.path);
        }, 500);
    };

    return (
        <Layout title="Early Learning">
            <div className="home-grid">
                {modules.map((m) => (
                    <BigButton
                        key={m.id}
                        label={m.label}
                        color={m.color}
                        icon={m.icon}
                        onClick={() => handleNavigate(m)}
                    />
                ))}
            </div>
        </Layout>
    );
};

export default Home;
